import { makeStyles } from "@mui/styles";

const useInstructionStyle = makeStyles(() => ({
  appContainer: {
    position: 'relative',
    width: '100%',
    height: '100vh',
    overflow: 'hidden'
  },
  backdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 30,
  },
  // Add any other styles you need here
}));

export default useInstructionStyle;